export enum GAJourneyVersion {
  MultiPlan = 'multi-plan',
  Notset = 'not-set',
  RegisterOnly = 'reg-only',
  SingleMultiPlan = 'single-multi-plan',
  SinglePlan = 'single-plan',
}
